export default __webpack_public_path__ + "static/media/business-01.f7d40bf3.jpg";